/* eslint-disable max-len */
/* eslint-disable indent */
const { getFrontSnippetPlaceholder } = require('./utils');
const { CountryOfOperationItems } = require('../utils/constants');
const { allPaymentMethods, allPaymentTypes } = require('./constants');

const componentCodeFront = (formData) => {
  const finalPaymentMethods = allPaymentMethods?.filter((method) => !formData.paymentMethods.includes(method));
  const finalPaymentTypes = allPaymentTypes?.filter((types) => !formData.paymentTypes.includes(types));

  try {
    return [
      {
        code: `
    <html>
      <head>
      <!-- The JS code can be included in a < script > tag or a separate JS file. -->
      <script src="https://sdk.mercadopago.com/js/v2"></script>
      </head>
      <body>
        <div id="brandBrick_container"></div>
        <script>
        const mp = new MercadoPago('YOUR_PUBLIC_KEY', {
            locale: '${CountryOfOperationItems.getFormatedLanguageByCountry(formData.publicKey, formData.language)}'
          });
          const bricksBuilder = mp.bricks();

          const renderBrandBrick = async (bricksBuilder) => {
            const settings = {
              customization: {
                texts: {
                  valueProp: '${formData?.valueProp || 'payment_methods'}',
                  align: '${formData?.align || 'left'}',
                  useCustomFont: ${formData?.useCustomFont || false},
                  size: '${formData?.size || 'medium'}',
                  fontWeight: '${formData?.fontWeight || 'semibold'}',
                  color: '${formData?.color || 'secondary'}',
                },
                paymentMethods: {
                  excludedPaymentMethods: [${finalPaymentMethods?.map((item) => `'${item}'`)}],
                  excludedPaymentTypes: [${finalPaymentTypes?.map((item) => `'${item}'`)}],
                  maxInstallments: ${formData?.maxInstallments || 12},
                  interestFreeInstallments: ${formData?.interestFreeInstallments || false},
                },
                visual: {
                  backgroundColor: '${formData?.backgroundColor || 'white'}', 
                  hideMercadoPagoLogo: ${!formData?.showMercadoPagoLogo || false},
                  border: ${formData?.border || false},
                  borderColor: '${formData?.borderColor || 'dark'}',
                  contentAlign: '${formData?.contentAlign || 'center'}',
                  borderWidth: '${formData?.borderWidth || 1}px',
                  borderRadius: '${formData?.borderRadius || 0}px',
                  verticalPadding: '${formData?.verticalPadding || 8}px',
                  horizontalPadding: '${formData?.horizontalPadding || 16}px',
                },
              },
              callbacks: {
                onReady: () => {
                /*
                Callback called when Brick is ready.
                Here you can hide loadings from your site, for example.
                */
                },
              },
            };
            window.brandBrickController = await bricksBuilder.create(
              'brand',
              'brandBrick_container',
              settings,
            );
          };
          renderBrandBrick(bricksBuilder);
        </script>
      </body>
    </html>
    `.replace(/^\s*[\r\n]/gm, ''),
        type: 'html',
        name: 'html',
      },
    ];
  } catch (e) {
    return [{
    code: getFrontSnippetPlaceholder(formData, finalPaymentMethods, finalPaymentTypes).replace(/^\s*[\r\n]/gm, ''),
    type: 'html',
    name: 'html' }];
  }
};

module.exports = componentCodeFront;
